import { render } from "./XacNhanHanhKhachXuongThucHienChuyenDi.vue?vue&type=template&id=f523ea18"
import script from "./XacNhanHanhKhachXuongThucHienChuyenDi.vue?vue&type=script&lang=js"
export * from "./XacNhanHanhKhachXuongThucHienChuyenDi.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__